export const imagePath = {
	methods: {
		imagePath(value) {
            return require('../assets/'+value);
        }
	}
}